import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  margin: 0 0 3rem 0;
  padding: 0;
  counter-reset: step;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 1024px) {
    margin: 0 0 2rem 0;
  }
`;

export const Item = styled.li`
  display: inline-block;
  list-style: none;
  color: #284a41;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 1px;
  text-align: center;
  word-break: break-all;
  @media (max-width: 1024px) {
    span {
      display: none;
    }
  }
  &:before {
    content: counter(step);
    counter-increment: step;
    width: 27px;
    height: 27px;
    line-height: 27px;
    display: block;
    font-size: 10px;
    color: #333;
    background: #bdc8ca;
    border-radius: 25px;
    margin: 0 auto 10px auto;
  }
  &.active {
    &:before,
    &:after {
      background: #536e67;
      color: white;
    }
  }
`;